import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Tooltip, Fab } from "@mui/material";
import Grid from '@mui/material/Grid2';
import { 
  Character,
  COptions,
} from "@dndModels";

import API from "@utilities/smart_api";
import DandDCharacterUtilities from "@dndUtilities/char_utilities";
// import DataUtilities from '../../utilities/common_utilities';

import ToggleButtonBox from "@components/input/buttons/ToggleButtonBox";
import FloatMenu from "@components/input/menus/FloatMenu";

import CharacterViewInventory from "@dndComponents/character/inventory/CharacterViewInventory";
import CharacterFeatures from "@dndComponents/character/features/CharacterFeatures";
import CharacterSpells from "@dndComponents/character/spells_and_abilities/CharacterSpells";
import CharacterProficiencies from "@dndComponents/character/misc/CharacterProficiencies";
import CharacterActions from "@dndComponents/character/spells_and_abilities/CharacterActions";
import CharacterAbilityScores from "@dndComponents/character/ability_scores/CharacterAbilityScores";
import CharacterSavingThrows from "@dndComponents/character/saves/CharacterSavingThrows";
import CharacterSenses from "@dndComponents/character/misc/CharacterSenses";
import CharacterSkills from "@dndComponents/character/skills/CharacterSkills";
import CharacterOptionsInput from "@dndComponents/character/misc/CharacterOptionsInput";
import CharacterBar3 from "@dndComponents/character/bar3/CharacterBar3";
import CharacterCampaignInfo from "@dndComponents/character/misc/CharacterCampaignInfo";
import ModalOrDrawer from "@components/display/ModalOrDrawer";
import CharacterDefenses from "@dndComponents/character/defenses/CharacterDefenses";
import CharacterConditions from "@dndComponents/character/conditions/CharacterConditions";
import CharacterMinions from "@dndComponents/character/minions/CharacterMinions";
import CharacterPassives from "@dndComponents/character/spells_and_abilities/CharacterPassives";
import CharacterLanguages from "@dndComponents/character/misc/CharacterLanguages";
import { useGetWidthCategory } from '@utilities/common_hooks';
import LoadingBox from '@components/input/LoadingBox';

interface Props {
  char: Character; 
  shared: boolean;
}

const api = API.getInstance();
const char_util = DandDCharacterUtilities.getInstance();
// const common_util = DataUtilities.getInstance();

export default function CharacterMainDetails({ 
  char, 
  shared,
}: Props) {
  const { ref, widthCategory } = useGetWidthCategory();
  const [menu_open, setMenuOpen] = useState("");
  const [the_view, setView2] = useState("Main");
  const [reloading, setReloading] = useState(false);
  const mounted = useRef(false);

  useEffect(() => { 
    mounted.current = true;

    return () => {
      mounted.current = false;
    };
  }, []);

  const transformed = useCallback(() => {
    console.log("transformed");
    console.log(char.spirit.transform);
    setReloading(true);
  }, [char]);

  const char_interface = char.char_interface;

  useEffect(() => {
    char.subscription_holder.subscribe("Transform", mounted, transformed);
  }, [char, transformed]);

  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading]);

  const setView = (v: string) => {
    setView2(v);
  }

  const renderExtras = () => {
    const campaign = char.campaign;
    return (
      <ModalOrDrawer
        open={ menu_open === "campaign" } 
        onClose={() => {
          setMenuOpen("");
        }}>
        { campaign && menu_open === "campaign" &&
          <CharacterCampaignInfo
            character={char}
            campaign={campaign}
          />
        }
      </ModalOrDrawer>
    );
  }

  const renderSelectedView = () => {
    // console.log("renderSelectedView");
    let return_me: any = <Grid>{the_view} Coming Soon</Grid>;
    // console.log(the_view);
    const main_options = char.campaign ? ["Actions","Spells","Inventory","Campaign Inventory","Features & Traits","Options"] : ["Actions","Spells","Inventory","Features & Traits","Options"];
    const menu_options = widthCategory !== "lg" ? ["Main",...main_options] : [...main_options];
    switch (the_view) {
      case "Main":
        if (widthCategory === "xs" || widthCategory === "sm") {
          return_me = (
            <>
              <Grid size={12}
                className="bg_black_transp">
                <FloatMenu 
                  options={menu_options}
                  selected={the_view}
                  onSelect={setView}
                />
              </Grid>
              <Grid size={12}>
                <CharacterAbilityScores 
                  character={char}
                  char_interface={char_interface}
                  shared={shared}
                />
              </Grid>
              <Grid size={12}>
                <CharacterSavingThrows 
                  char={char}
                  char_interface={char_interface}
                  shared={shared}
                />
              </Grid>
              <Grid size={12}>
                <CharacterSenses
                  character={char} 
                  char_interface={char_interface}
                  disabled={shared}
                />
              </Grid>
              <Grid size={12}>
                <CharacterProficiencies 
                  char={char}
                  char_interface={char_interface}
                  disabled={shared}
                />
              </Grid>
              <Grid size={12}>
                <CharacterLanguages 
                  char={char}
                  disabled={shared}
                />
              </Grid>
              <Grid size={12}>
                <CharacterSkills 
                  char={char_interface} 
                  shared={shared}
                />
              </Grid>
              <Grid size={12}>
                <CharacterDefenses 
                  char={char_interface} 
                  shared={shared}
                />
              </Grid>
              <Grid size={12}>
                <CharacterConditions 
                  char={char_interface} 
                  shared={shared}
                />
              </Grid>
              <Grid size={12}>
                <CharacterMinions 
                  char={char} 
                  shared={shared}
                />
              </Grid>
              <Grid size={12}>
                <CharacterPassives
                  char={char}
                  char_int={char_interface}
                  shared={shared}
                />
              </Grid>
            </>
          );
        } else if (widthCategory === "md") {
          return_me = (
            <>
              <Grid size={12}
                className="bg_black_transp">
                <FloatMenu 
                  options={menu_options}
                  selected={the_view}
                  onSelect={setView}
                />
              </Grid>
              <Grid size={12}>
                <CharacterAbilityScores 
                  character={char}
                  char_interface={char_interface}
                  shared={shared}
                  horizontal
                />
              </Grid>
              <Grid size={6}>
                <Grid container spacing={0} direction="row">
                  <Grid size={12}>
                    <CharacterSavingThrows 
                      char={char}
                      char_interface={char_interface}
                      shared={shared}
                      vertical
                    />
                  </Grid>
                  <Grid size={12}>
                    <CharacterSenses
                      character={char} 
                      char_interface={char_interface}
                      disabled={shared}
                    />
                  </Grid>
                  <Grid size={12}>
                    <CharacterProficiencies 
                      char={char}
                      char_interface={char_interface}
                      disabled={shared}
                    />
                  </Grid>
                  <Grid size={12}>
                    <CharacterLanguages 
                      char={char}
                      disabled={shared}
                    />
                  </Grid>
                  <Grid size={12}>
                    <CharacterDefenses 
                      char={char_interface} 
                      shared={shared}
                    />
                  </Grid>
                  <Grid size={12}>
                    <CharacterConditions 
                      char={char_interface} 
                      shared={shared}
                    />
                  </Grid>
                  <Grid size={12}>
                    <CharacterMinions 
                      char={char} 
                      shared={shared}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid size={6}>
                <Grid container spacing={0} direction="row">
                  <Grid size={12}>
                    <CharacterSkills 
                      char={char_interface} 
                      shared={shared}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid size={12}>
                <CharacterPassives
                  char={char}
                  char_int={char_interface}
                  shared={shared}
                />
              </Grid>
            </>
          );
        } else {
          return_me = 
            <>
              <Grid size={12}
                className="bg_black_transp">
                <FloatMenu 
                  options={menu_options}
                  selected={the_view}
                  onSelect={setView}
                />
              </Grid>
              <Grid size={12}>
                <CharacterActions 
                  char={char}
                  char_int={char_interface}
                  shared={shared}
                />
              </Grid>
            </>;
        }
      break;
      case "Inventory":
        return_me = 
          <>
            <Grid size={12}
              className="bg_black_transp">
              <FloatMenu 
                options={menu_options}
                selected={the_view}
                onSelect={setView}
              />
            </Grid>
            <Grid size={12}>
              <CharacterViewInventory 
                char={char}
                inventory={char.inventory}
                disabled={shared}
                shared={shared}
              />
            </Grid>
          </>;
      break;
      case "Campaign Inventory":
        if (char.campaign) {
          return_me = 
            <>
              <Grid size={12}
                className="bg_black_transp">
                <FloatMenu 
                  options={menu_options}
                  selected={the_view}
                  onSelect={setView}
                />
              </Grid>
              <Grid size={12}>
                <CharacterViewInventory 
                  char={char}
                  inventory={char.campaign.inventory}
                  disabled={shared}
                  shared={shared}
                />
              </Grid>
            </>;
        }
      break;
      case "Features & Traits":
        return_me = 
          <>
            <Grid
              className="bg_black_transp"
              size={{
                xs: 12
              }}>
              <FloatMenu 
                options={menu_options}
                selected={the_view}
                onSelect={setView}
              />
            </Grid>
            <Grid
              size={{
                xs: 12
              }}>
              <CharacterFeatures 
                char={char}
              />
            </Grid>
          </>;
      break;
      case "Spells":
        return_me = 
          <>
            <Grid
              className="bg_black_transp"
              size={{
                xs: 12
              }}>
              <FloatMenu 
                options={menu_options}
                selected={the_view}
                onSelect={setView}
              />
            </Grid>
            <Grid
              size={{
                xs: 12
              }}>
              <CharacterSpells 
                char={char}
                char_int={char_interface}
                // campaign={campaign}
                shared={shared}
              />
            </Grid>
          </>;
      break;
      case "Actions":
        return_me = 
          <>
            <Grid
              className="bg_black_transp"
              size={{
                xs: 12
              }}>
              <FloatMenu 
                options={menu_options}
                selected={the_view}
                onSelect={setView}
              />
            </Grid>
            <Grid
              size={{
                xs: 12
              }}>
              <CharacterActions 
                char={char}
                char_int={char_interface}
                shared={shared}
              />
            </Grid>
          </>;
      break;
      case "Options":
        return_me = 
          <>
            <Grid size={12} className="bg_black_transp">
              <FloatMenu 
                options={menu_options}
                selected={the_view}
                onSelect={setView}
              />
            </Grid>
            <Grid size={12}>
              <CharacterOptionsInput 
                obj={char}
                disabled={shared}
                onChange={ async (character_options: COptions) => {
                  // debugger;
                  char.c_options.copy(character_options);
                  
                  api.removeCharacterCookies(char._id);
                  char.changed();
                  char.last_saved = char.last_changed;
                  char.cookie_saved = char.last_changed;
                  char_util.enforceOptions(char);
                  await api.updateCharacter(char, ["all"]);
                  char_util.emptyHash();
                  char.subscription_holder.reload();
                }}
              />
            </Grid>
          </>;
      break;
    }
    if (widthCategory === "lg") {
      return_me = (
        <>
          <Grid size={6}>
            <Grid container spacing={0} direction="row">
              <Grid size={12}>
                <CharacterAbilityScores 
                  character={char}
                  char_interface={char_interface}
                  shared={shared}
                  horizontal
                />
              </Grid>
              <Grid size={12}
                container spacing={0} direction="row">
                <Grid size={6}>
                  <Grid container spacing={0} direction="row">
                    <Grid size={12}>
                      <CharacterSavingThrows 
                        char={char}
                        char_interface={char_interface}
                        shared={shared}
                        vertical
                      />
                    </Grid>
                    <Grid size={12}>
                      <CharacterSenses
                        character={char} 
                        char_interface={char_interface}
                        disabled={shared}
                      />
                    </Grid>
                    <Grid size={12}>
                      <CharacterProficiencies 
                        char={char}
                        char_interface={char_interface}
                        disabled={shared}
                      />
                    </Grid>
                    <Grid size={12}>
                      <CharacterLanguages 
                        char={char}
                        disabled={shared}
                      />
                    </Grid>
                    <Grid size={12}>
                      <CharacterDefenses 
                        char={char_interface} 
                        shared={shared}
                      />
                    </Grid>
                    <Grid size={12}>
                      <CharacterConditions 
                        char={char_interface} 
                        shared={shared}
                      />
                    </Grid>
                    <Grid size={12}>
                      <CharacterMinions 
                        char={char} 
                        shared={shared}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid size={6}>
                  <Grid container spacing={0} direction="row">
                    <Grid size={12}>
                      <CharacterSkills 
                        char={char_interface} 
                        shared={shared}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid size={12}>
                  <CharacterPassives
                    char={char}
                    char_int={char_interface}
                    shared={shared}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid size={6}>
            <Grid container spacing={0} direction="row">
              { return_me }
            </Grid>
          </Grid>
        </>
      );
    }
    return return_me;
  }

  if (reloading) {
    return (<LoadingBox />);
  }
  return (
    <Grid ref={ref} container spacing={0} direction="row" style={{ lineHeight: "1.5" }}>
      <Grid size={12}
        style={{ 
          borderTop: "1px solid",
          borderBottom: "1px solid" 
        }}>
        <CharacterBar3
          char={char}
          char_interface={char_interface}
          shared={shared}
        />
      </Grid>
      <Grid size={12}
        container spacing={0} direction="row"
        className="padded">
        <Grid size={12}
          container spacing={0} direction="row">
          {/* <Grid size={1}>
            <Tooltip title={ default_view === the_view ? "This is your default view" : `Make Default View` }>
              <Fab size="small" color={ default_view !== the_view ? "primary" : undefined } style={{ marginLeft: "8px", backgroundColor: (default_view === the_view ? "gray" : undefined)}}
                onClick={ () => {
                  if (default_view !== the_view) {
                    character.default_view = the_view;
                    character.changed();
                    setDefaultView(the_view);
                  }
                }}>
                  <svg className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium  css-w2bhrx" focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="PushPinIcon" aria-label="fontSize medium"><path fillRule="evenodd" d="M16 9V4h1c.55 0 1-.45 1-1s-.45-1-1-1H7c-.55 0-1 .45-1 1s.45 1 1 1h1v5c0 1.66-1.34 3-3 3v2h5.97v7l1 1 1-1v-7H19v-2c-1.66 0-3-1.34-3-3z"></path></svg>
              </Fab>
            </Tooltip>
          </Grid> */}
          <Grid size={12}>
            { char.campaign && 
              <div className="bg_black_transp">
                <ToggleButtonBox
                  name={char.campaign.name}
                  value={false} 
                  onToggle={() => {
                    setMenuOpen("campaign");
                  }} 
                />
              </div>
            }
          </Grid>
        </Grid>
        { renderSelectedView() }
        <Grid size={12} style={{ height: "60px" }}>&nbsp;</Grid>
      </Grid>
      { renderExtras() }
    </Grid>
  );
}
